// Import Vue
import { createApp } from 'vue';

// Import Framework7
import Framework7 from 'framework7/lite-bundle';

// Import Framework7-Vue Plugin
import Framework7Vue, { registerComponents } from 'framework7-vue/bundle';

// Import Framework7 Styles
import 'framework7/css/bundle';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.scss';

import { store } from '../store/index'

// Import App Component
import App from '../components/app.vue';

// Import Sentry
import { initSentry, setSentryUser } from './sentry.js';

// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);

// Init App
const app = createApp(App);

window.app = app;

// Initialize Sentry (must be before mount to capture init errors)
initSentry(app);

// Register Framework7 Vue components
registerComponents(app);

app.use(store);

// Mount the app
app.mount('#app');

// Set Sentry user context when logged-in user changes
// This handles: initial load from persisted Vuex state, login, logout, impersonate
store.watch(
  (state) => state.current_user.data,
  (userData) => {
    if (userData && userData.id) {
      setSentryUser({ id: userData.id, email: userData.email });
    } else {
      setSentryUser(null);
    }
  },
  { immediate: true, deep: false }
);
